import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorDialogData } from './error-dialog-data';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ErrorDialogComponent {
  msg?: string;
  title?: string;
  subTitle?: string;
  exception?: any;

  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorDialogData,
  ) {
    this.msg = data.msg;
    this.title = data.title ?? $localize`:@@error.default-title:Error`;
    this.subTitle = data.subTitle;
    this.exception = data.exception;
  }

  get exceptionIsObject(): boolean {
    return this.exception instanceof Object;
  }

  get exceptionText(): string {
    return this.exceptionIsObject
      ? JSON.stringify(this.exception)
      : this.exception;
  }

}

